import { withStyles, Grid } from '@material-ui/core';
import { isArray, isString } from '@material-ui/data-grid';
import React, { HTMLAttributes } from 'react';

export const SymbolDiv = (
  props: HTMLAttributes<HTMLDivElement>
): JSX.Element => {
  const { style = {}, children = '~', ...other } = props;
  return (
    <div
      {...other}
      style={{
        color: '#656565',
        padding: '0 5px',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export const VcGrid = withStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
})(Grid);
export const VcEGrid = withStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
})(Grid);
export const HVcGrid = withStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})(Grid);

export const EvenlyGrid = withStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
})(Grid);

export const RequiredText = (
  props: HTMLAttributes<HTMLSpanElement>
): JSX.Element => {
  const { children, ...other } = props;
  return (
    <span style={{ margin: '5px 0' }} {...other}>
      {(isString(children) || isArray(children)) && children[0] === '*' ? (
        <>
          <span style={{ color: 'red', display: 'contents' }}>*</span>
          {isString(children) ? (children || '').substring(1) : children[1]}
        </>
      ) : (
        children
      )}
    </span>
  );
};

export const FormTitle = (
  props: HTMLAttributes<HTMLSpanElement>
): JSX.Element => {
  const { children, ...other } = props;
  return <RequiredText {...other}>{children}</RequiredText>;
};
